// Auto-generated version info
export const VERSION = '1.0.0';
export const BUILD_DATE = new Date().toISOString();
export const NODE_VERSION = process.version;